import { Controller } from "@hotwired/stimulus"

// Pushes the server-rendered `events` array onto window.dataLayer - the GA4/GTM boundary this app
// owns. Nothing here makes a network call; GTM (loaded separately, and disabled in test) is what
// reads dataLayer from there.
export default class extends Controller {
  static get values() {
    return { events: Array };
  }

  connect() {
    if (!this.hasEventsValue) { return; }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(...this.eventsValue);
  }
}
